export default {
  // layout
  gridStep: 12,
  defaultWidth: 1280,
  largeWidth: 1440,
  mobileWidth: 640,
  layoutPadding: 2.5,
  mobileLayoutPadding: 1.25,
  headerOffset: 162,
  headerOffsetMobile: 57,
  // fonts
  defaultFontSize: 16,
  mobileFontSize: 14,
  defaultMinFontSizeKiosk: 12,
  defaultFontWeight: 400,
  // colors
  colorRed: '#eb0000',
  colorRed2: '#e1251b',
  colorRed3: '#e1261c',
  colorRedHover: '#c72118',
  colorGrey: '#7C7F83',
  colorGrey2: '#f4f4f4',
  colorBlue: '#b4d7e9',
  colorPaleGrey: '#f5f5f5',
  colorGreyLight: '#f3f3f3',
  colorGreyLight2: '#96989b',
  colorGreyLight3: '#e6e6e6',
  colorGreyMedium: '#dbdbdb',
  colorGreyMedium1: '#dddddd',
  colorGreyMedium2: '#6b6b6b',
  colorGreyMedium3: '#f6f6f8',
  colorGreyDark: '#979797',
  colorGreyExtraDark: '#202126',
  colorGreyBorder: '#d5d5d5',
  colorBlack: '#333333',
  colorBlackHover: '#000000',
  colorBlackAlt: '#000000',
  colorWhite: '#ffffff',
  colorWhiteHover: '#ebebeb',
  defaultBackground: '#ffffff',
  colorBlueMedium: '#afdbf3',
  colorBlueLight: '#cbeaf9',
  colorGreen: '#348800',
  colorYellowLight: '#f8efa0',
  colorPink: '#feece8',
  colorPinkAlt: '#f9dada',
  colorVelvet: '#3d1952',
};
